var _path, _path2, _path3, _path4, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubroomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0309 18.9716C14.2542 19.3583 14.2542 19.8348 14.0309 20.2216L11.484 24.633C11.2607 25.0197 10.8481 25.258 10.4015 25.258L5.30767 25.258C4.86109 25.258 4.44843 25.0197 4.22514 24.633L1.67823 20.2216C1.45494 19.8348 1.45494 19.3583 1.67823 18.9716L4.22514 14.5602C4.44843 14.1735 4.86109 13.9352 5.30767 13.9352L10.4015 13.9352C10.8481 13.9352 11.2607 14.1735 11.484 14.5602L14.0309 18.9716Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6097 6.40764C32.6543 6.48499 32.6543 6.58029 32.6097 6.65764L31.2273 9.0519C31.1827 9.12925 31.1001 9.1769 31.0108 9.1769L28.2462 9.1769C28.1569 9.1769 28.0743 9.12925 28.0297 9.0519L26.6473 6.65764C26.6027 6.58029 26.6027 6.48499 26.6473 6.40764L28.0297 4.01337C28.0743 3.93602 28.1569 3.88837 28.2462 3.88837L31.0108 3.88838C31.1001 3.88838 31.1827 3.93602 31.2273 4.01338L32.6097 6.40764Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8352 3.79436C10.8799 3.87171 10.8799 3.967 10.8352 4.04436L9.45292 6.43862C9.40826 6.51597 9.32573 6.56362 9.23641 6.56362L6.47176 6.56362C6.38244 6.56362 6.29991 6.51597 6.25525 6.43862L4.87292 4.04435C4.82826 3.96701 4.82826 3.87171 4.87292 3.79435L6.25525 1.40009C6.29991 1.32274 6.38244 1.27509 6.47176 1.27509L9.23641 1.27509C9.32573 1.27509 9.40826 1.32274 9.45292 1.40009L10.8352 3.79436Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.513 22.521C26.5576 22.5983 26.5576 22.6936 26.513 22.771L25.3484 24.7881C25.3037 24.8655 25.2212 24.9131 25.1319 24.9131L22.8027 24.9131C22.7134 24.9131 22.6309 24.8655 22.5862 24.7881L21.4216 22.771C21.377 22.6936 21.377 22.5983 21.4216 22.521L22.5862 20.5039C22.6309 20.4265 22.7134 20.3789 22.8027 20.3789L25.1319 20.3789C25.2212 20.3789 25.3037 20.4265 25.3484 20.5039L26.513 22.521Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.54004,
    y1: 13.9355,
    x2: 7.54004,
    y2: 6.9678,
    stroke: "white",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.6445,
    y1: 22.7656,
    x2: 21.3542,
    y2: 22.7656,
    stroke: "white",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.1181,
    y1: 16.7839,
    x2: 27.0536,
    y2: 8.07425,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubroomIcon);
export default __webpack_public_path__ + "static/media/subroom-icon.52e4f5b9.svg";
export { ForwardRef as ReactComponent };